import type { EditorThemeClasses } from "lexical";

export const editorTheme: EditorThemeClasses = {
  paragraph: "mb-1 last:mb-0",
  heading: {
    h1: "text-3xl font-bold leading-tight mt-4 mb-2",
    h2: "text-2xl font-semibold leading-snug mt-3 mb-2",
    h3: "text-xl font-semibold leading-snug mt-3 mb-1.5",
  },
  text: {
    bold: "font-bold",
    italic: "italic",
    underline: "underline",
    strikethrough: "line-through",
    code: "bg-muted px-1 py-0.5 rounded font-mono text-sm",
  },
  list: {
    nested: {
      listitem: "list-none",
    },
    ol: "list-decimal list-inside ml-4",
    ul: "list-disc list-inside ml-4",
    listitem: "my-0.5",
    listitemChecked: "line-through text-muted-foreground",
    listitemUnchecked: "",
  },
  code: "editor-code-block",
  codeHighlight: {
    atrule: "token-atrule",
    attr: "token-attr",
    boolean: "token-boolean",
    builtin: "token-builtin",
    cdata: "token-cdata",
    char: "token-char",
    class: "token-class",
    "class-name": "token-class-name",
    comment: "token-comment",
    constant: "token-constant",
    deleted: "token-deleted",
    doctype: "token-doctype",
    entity: "token-entity",
    function: "token-function",
    important: "token-important",
    inserted: "token-inserted",
    keyword: "token-keyword",
    namespace: "token-namespace",
    number: "token-number",
    operator: "token-operator",
    prolog: "token-prolog",
    property: "token-property",
    punctuation: "token-punctuation",
    regex: "token-regex",
    selector: "token-selector",
    string: "token-string",
    symbol: "token-symbol",
    tag: "token-tag",
    url: "token-url",
    variable: "token-variable",
  },
  quote: "border-l-3 border-border pl-3 text-muted-foreground",
  link: "text-primary hover:underline cursor-pointer",
  hashtag: "text-primary",
};
